// import { request } from 'umi'; <-- Remove this
import { organizationAPI } from './organizationAPI'; // Placeholder import to get type access if needed, or just remove
// Actually we need the 'api' instance we used in other services.
// Let's check how other services import it. 
// checking supplyChainService.ts
import api from './api';


export interface AdCampaign {
    id: number;
    campaign_id?: string;
    name: string;
    campaign_type: string;
    status: string;
    daily_budget?: number;
    start_date?: string;
    end_date?: string;
}

export interface AdGroup {
    id: number;
    name: string;
    default_bid: number;
    status: string;
}

export interface AdReport {
    id: number;
    date: string;
    campaign_name: string;
    ad_group_name: string;
    target_text?: string;
    search_term?: string;
    impressions: number;
    clicks: number;
    spend: number;
    sales: number;
    orders: number;
    acos: number;
    roas: number;
    cpc: number;
    ctr: number;
}

export interface AdReportUploadParams {
    file: File;
    report_type: 'search_term' | 'campaign_performance' | 'advertised_product';
    date?: string;
}

// 假设我们使用从 services/api 导入的通用 request 或者 axios 实例


export const advertisingAPI = {
    // 获取广告活动列表
    getCampaigns: (params?: any) => {
        return api.get('/marketing/advertising/', { params });
    },

    // 上传报表
    uploadReport: (data: AdReportUploadParams) => {
        const formData = new FormData();
        formData.append('file', data.file);
        formData.append('report_type', data.report_type);
        if (data.date) {
            formData.append('date', data.date);
        }

        return api.post('/marketing/advertising/upload_report/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    },

    // 获取报表数据 (用于看板)
    getReports: (params?: any) => {
        // 由于后台暂未暴露 AdReport 的 List 接口，这里暂时保留
        // 建议在 AdvertisingViewSet 中添加 list_reports action
        return api.get('/marketing/advertising/reports/', { params });
    }
};
